import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cinco-admin/artifacts/gnzt6mea_knto-cinco-icon-black-rgb-900px-w-72ppi.jpg";

export default function LoginPage() {
  const { user, loading } = useAuth();

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50">
        <div className="w-6 h-6 border-2 border-zinc-300 border-t-zinc-900 rounded-full animate-spin" />
      </div>
    );
  }

  // Already authenticated — skip login page
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      {/* Left - Login Form */}
      <div className="flex-1 flex flex-col items-center justify-center px-8 bg-white">
        <div className="w-full max-w-sm space-y-10">
          {/* Logo & Branding */}
          <div className="space-y-4">
            <img
              src={LOGO_URL}
              alt="Knto Cinco"
              className="w-16 h-16"
              data-testid="login-logo"
            />
            <div>
              <h1 className="font-heading text-4xl font-bold tracking-tight text-zinc-900">
                Knto Cinco
              </h1>
              <p className="text-base text-zinc-500 mt-2 font-body leading-relaxed">
                Coffee shop management system
              </p>
            </div>
          </div>

          {/* Login Button */}
          <div className="space-y-4">
            <Button
              data-testid="google-login-btn"
              onClick={handleGoogleLogin}
              className="w-full bg-zinc-900 text-white hover:bg-zinc-800 rounded-lg px-6 py-6 font-medium transition-all active:scale-[0.98] flex items-center justify-center gap-3 text-base"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
              Continue with Google
            </Button>
            <p className="text-xs text-zinc-400 text-center">
              Secure login powered by Google
            </p>
          </div>

          {/* Footer */}
          <div className="pt-8 border-t border-zinc-100">
            <p className="text-xs text-zinc-400 text-center">
              Davao City
            </p>
          </div>
        </div>
      </div>

      {/* Right - Image */}
      <div className="hidden lg:block flex-1 relative overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1769987030159-bba5626103f7?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Coffee shop"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-zinc-900/10" />
      </div>
    </div>
  );
}
